import { preview } from '@/components/form/preview'
import { useTexts } from './hooks/useTexts'
import { useActions } from './hooks/useActions'
import { PreviewActions } from './components/PreviewActions/PreviewActions'
import { PreviewTabs } from './components/PreviewTabs'
import { useState } from 'react'

type Props = {
  orders: uui.domain.client.rm.ExtendedOrderStep[]
}

export function Header(props: Props) {
  const { orders } = props

  const actions = useActions()
  const texts = useTexts()
  const [tab, setTab] = useState(0)

  return (
    <preview.Header
      title={texts.title(orders.length)}
      testId="order-view-header"
      onClose={actions.onReset}
    >
      <PreviewActions orders={orders} />
      <PreviewTabs tab={tab} setTab={setTab} />
    </preview.Header>
  )
}
